var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.652588,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF493"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0234 10.9922L16.8359 19.0156H15.2266L15.0312 10.9922H17.0234ZM14.9766 21.4766C14.9766 21.1901 15.0703 20.9505 15.2578 20.7578C15.4505 20.5599 15.7161 20.4609 16.0547 20.4609C16.388 20.4609 16.651 20.5599 16.8438 20.7578C17.0365 20.9505 17.1328 21.1901 17.1328 21.4766C17.1328 21.7526 17.0365 21.9896 16.8438 22.1875C16.651 22.3802 16.388 22.4766 16.0547 22.4766C15.7161 22.4766 15.4505 22.3802 15.2578 22.1875C15.0703 21.9896 14.9766 21.7526 14.9766 21.4766Z",
    fill: "#FCA600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.43538a6dc6126c4e3df8fae7bfc30c02.svg";
export { ForwardRef as ReactComponent };